import { render } from "./DeleteIcon.vue?vue&type=template&id=351de2a1&ts=true"
import script from "./DeleteIcon.ts?vue&type=script&lang=ts"
export * from "./DeleteIcon.ts?vue&type=script&lang=ts"

import exportComponent from "/github/workspace/RC.Estimatifs/rc-estimatifs-web/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__